<form ngNativeValidate>
    <div class="modal-container">
      <div class="modal-header border-0 justify-content-start">
        <h1 class="modal-title text-center text-primary-color">Assign</h1>
      </div>
      <div class="modal-body">
        <div [ngClass]="{'mb-3' : !dropdownHidden}">
            <app-dropdown
                [selectLabel]="'Salesperson'"
                [data]="salesPersonList"
                [selectValue]="assignModel.salesPersonId"
                (selectValueEmit)="assignModel.salesPersonId = $event" 
                [hidden]="dropdownHidden"
                [optionDisable]="assignModel.altSalesPersonId"
                [required]="false">
            </app-dropdown>
        </div>
        <div [ngClass]="{'mb-3' : !dropdownHidden}">
            <!-- select-container -->
            <app-dropdown
                [selectLabel]="'Alt Salesperson'"
                [data]="altSalesPersonList" 
                [optionDisable]="assignModel.salesPersonId"
                [selectValue]="assignModel.altSalesPersonId"
                (selectValueEmit)="assignModel.altSalesPersonId = $event" 
                [hidden]="dropdownHidden"
                [required]="false">
            </app-dropdown>
        </div>
        <div class="">
            <!-- select-container -->
            <app-dropdown
                [selectLabel]="'Buyer’s Rep'"
                [data]="buyeresRepList"
                [selectValue]="assignModel.buyersId"
                (selectValueEmit)="assignModel.buyersId = $event" 
                [required]="false">
            </app-dropdown>
        </div>
      </div>
      <div class="modal-footer border-0 justify-content-center gap-3">
        <!-- <div class="mb-2"> -->
          <!-- <button type="submit">Done</button> -->
          <app-button 
            [buttonType]="'button'"  
            [button_2]="true" 
            [buttonClass]="'button popup-button button-info'" 
            (click)="activeModal.close()" 
            [buttonLable]="enumButtonName.CANCEL">
          </app-button>
          <app-button 
            [buttonType]="'submit'"  
            [button_2]="true"  
            [buttonClass]="'button popup-button button-primary'" 
            (click)="(assignModel.salesPersonId || assignModel.altSalesPersonId || assignModel.buyersId)? assignCompanyToRole():''" 
            [buttonLable]="enumButtonName.APPLY">
        </app-button>
        <!-- </div> -->
      </div>
    </div>
    </form>
    